import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(t) {
  var r = _isNativeReflectConstruct();
  return function () {
    var e,
      o = _getPrototypeOf(t);
    if (r) {
      var s = _getPrototypeOf(this).constructor;
      e = Reflect.construct(o, arguments, s);
    } else e = o.apply(this, arguments);
    return _possibleConstructorReturn(this, e);
  };
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
import React from 'react';
import { Grid, Header } from 'semantic-ui-react';
import { BlogPostPropType } from '../../../../services/proptypes';
import ObjectUtils from '../../../../utils/ObjectUtils';
import FeaturedBlogPost from '../FeaturedBlogPost/FeaturedBlogPost';
import './BlogPostNavigationHeader.css';
var BlogPostNavigationHeader = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(BlogPostNavigationHeader, _React$PureComponent);
  var _super = _createSuper(BlogPostNavigationHeader);
  function BlogPostNavigationHeader() {
    _classCallCheck(this, BlogPostNavigationHeader);
    return _super.apply(this, arguments);
  }
  _createClass(BlogPostNavigationHeader, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        title = _this$props.title,
        description = _this$props.description,
        featuredPostId = _this$props.featuredPostId,
        posts = _this$props.posts;
      var featuredPost = posts.find(function (_ref) {
        var postId = _ref._id;
        return postId === featuredPostId;
      });
      var isDescription = ObjectUtils.isRenderable(description);
      var isFeaturedPost = ObjectUtils.isRenderable(featuredPost);
      return /*#__PURE__*/React.createElement(React.Fragment, null, title && /*#__PURE__*/React.createElement(Header, {
        as: "h1",
        dividing: true
      }, title), /*#__PURE__*/React.createElement(Grid, {
        stackable: true
      }, isDescription && /*#__PURE__*/React.createElement(Grid.Column, {
        width: isFeaturedPost ? 6 : 16
      }, /*#__PURE__*/React.createElement("p", null, description)), isFeaturedPost && /*#__PURE__*/React.createElement(Grid.Column, {
        width: isDescription ? 10 : 16
      }, /*#__PURE__*/React.createElement(FeaturedBlogPost, featuredPost))));
    }
  }]);
  return BlogPostNavigationHeader;
}(React.PureComponent);
export { BlogPostNavigationHeader as default };
BlogPostNavigationHeader.defaultProps = {
  title: 'Blog',
  description: '',
  featuredPostId: null
};